
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/podcasts-masterclasses/series/[slug]",
      function () {
        return require("private-next-pages/podcasts-masterclasses/series/[slug].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/podcasts-masterclasses/series/[slug]"])
      });
    }
  